import { displayAddressPermissions } from '../../../../backend/extraTypes';
import { defineColumns } from '@juvare/platform-shared/features/storage';
import { z } from 'zod';
export const shiftEntityName = 'shift';
export const shiftPositionSchema = z.object({
    positionId: z.string().uuid(),
    quantity: z.number(),
});
export const shiftSchema = z.object({
    missionId: z.string().uuid(),
    startTime: z.number(),
    duration: z.number(),
    positions: z.array(shiftPositionSchema),
    checkInAddressId: z.string().trim().min(1),
    checkInAddress: z.string().trim().min(1),
    contactName: z.string().trim().min(1),
    contactEmail: z.string().email(),
    contactPhone: z.string().trim().min(1),
    permission: z.enum(displayAddressPermissions),
    displayShiftContact: z.boolean(),
    displayNumberOfPositions: z.boolean(),
    usersApprovedForShift: z.string().trim().min(1).array().optional(),
    shiftPositions: z.any().array().optional(), // TODO: Change to use Zod typed columns after PLAT-2704
    duplicatedShiftId: z.string().uuid().optional(),
});
const partialShiftSchema = shiftSchema.omit({ shiftPositions: true });
export const shiftColumns = defineColumns({
    search: {
        type: 'full-text-search-required',
        language: 'english',
    },
    missionId: {
        type: 'id-required',
        index: true,
    },
    missionTypeId: {
        type: 'id-required',
        index: true,
    },
    startTime: {
        type: 'number-required',
    },
    usersApprovedForShift: {
        type: 'id-array',
        index: true,
    },
    stopTime: {
        type: 'number-required',
    },
    countyName: {
        type: 'string-required',
        index: true,
    },
    contactName: {
        type: 'string-required',
    },
    contactEmail: {
        type: 'string-required',
    },
    contactPhone: {
        type: 'string-required',
    },
    displayShiftContact: {
        type: 'boolean-required',
    },
    displayNumberOfPositions: {
        type: 'boolean-required',
    },
    locationName: {
        type: 'string-required',
    },
    address: {
        type: 'string-required',
    },
    address2: {
        type: 'string',
    },
    city: {
        type: 'string-required',
    },
    zip: {
        type: 'string-required',
    },
    state: {
        type: 'string-required',
    },
    addressPermission: {
        type: 'string-required',
    },
    positionIds: {
        type: 'id-array-required',
    },
    positionWithQuantity: {
        type: 'string-array',
    },
    totalParticipantSlots: {
        type: 'number-required',
    },
});
